//main purpose of creating those types was to be able to use them in both table-core and table-helpers

export enum LockableField {
  rrp = 'rrp',
  rm = 'rm',
  lp = 'lp',
}

//fields that exist in both create price and simulationa and are needed for the calculations
export type BaseRowData = {
  primaryKey: string;
  productId: number;
  productCount?: number; //only needed for reports in simulation
  rrp: number;
  lp: number;
  rm: number;
  vat?: number | null | undefined;
  rrpIndexLocalLead: number;
  localLeadRrp: number;
  localLeadRm: number;
  priceUnitId: number;
  lpIndexLocalLead: number;
  localLeadLp: number;
  listPriceFmcFactor: number;
  fmcLocal: number;
  currencyDecimals: number;
  localLeadCurrencyDecimals: number;
  globalLeadCurrencyDecimals: number;
  isExemptFromFiltering?: boolean; // true if a row was edited after a filter that would exclude the row was applied; resets when filters are changed
};

export type BaseRowDataForDisplay = {
  primaryKey: string;
  priceUnitId: number;
  rm: string;
  rrp: string;
  lp: string;
  localLeadRrp: string;
  rrpIndexLocalLead: number;
  isExemptFromFiltering?: boolean;
};

export enum LaunchStatus {
  CarryOver = 'C',
  Outgoing = 'O',
  FirstHalf = '1HY',
  SecondHalf = '2HY',
}

export type ColumnAttributes = {
  label: string;
  exportLabel?: string;
  size: number;
  alignment: 'left' | 'right';
  columnType?: 'editable';
  hidden?: boolean;
  excluded?: boolean;
  aggregationFn?: 'count';
};

export type EditableField = LockableField | 'vat';

// Numeric filter modes for switchable filtering
export type NumericFilterMode =
  | 'values' // Default: multi-select dropdown
  | 'betweenInclusive' // >= min AND <= max
  | 'betweenExclusive' // > min AND < max
  | 'greaterThan' // >
  | 'greaterThanOrEqual' // >=
  | 'lessThan' // <
  | 'lessThanOrEqual'; // <=

export type NumericFilterValue = {
  mode: NumericFilterMode;
  selectedValues?: string[]; // For 'values' mode
  min?: number; // For between modes
  max?: number; // For between modes
  value?: number; // For single value modes
};
